import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { DebouncedInput, Icon, Input } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

import type { ICreativesFilters } from './EventCreativesPage';

interface IProps {
  filters: ICreativesFilters;
  setFilters: (filters: ICreativesFilters) => void;
}

function CreativesNameSearch({ filters, setFilters }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  function handleDebouncedSearchChange(newValue?: string): void {
    setFilters({
      ...filters,
      name__icontains: newValue,
    });
  }

  return (
    <DebouncedInput defaultValue={filters.name__icontains} onChange={handleDebouncedSearchChange}>
      {(liveValue, onChangeLiveValue): JSX.Element => (
        <Input
          onChange={onChangeLiveValue}
          placeholder={t('Search by name')}
          prefix={<Icon icon={(): JSX.Element => getIconForAction('search')} />}
          type={'text'}
          value={liveValue}
        />
      )}
    </DebouncedInput>
  );
}

export default CreativesNameSearch;
